/* Local UI only. Shopify remains the authority for prices, variants and cart. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-db-theme-toggle]').forEach(button => {
      if (button.dataset.dbReady) return;
      button.dataset.dbReady = 'true';
      const sync = () => {
        const dark = document.documentElement.dataset.dbAppearance === 'dark';
        button.setAttribute('aria-pressed', String(dark));
        button.setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode sombre');
      };
      sync();
      button.addEventListener('click', () => {
        const value = document.documentElement.dataset.dbAppearance === 'dark' ? 'light' : 'dark';
        document.documentElement.dataset.dbAppearance = value;
        try { localStorage.setItem('dobranoc-appearance', value); } catch (_) {}
        sync();
      });
    });
    scope.querySelectorAll('[data-db-size-guide]').forEach(guide => {
      if (guide.dataset.dbReady) return;
      guide.dataset.dbReady = 'true';
      const mattress = guide.querySelector('[data-db-mattress]');
      const duvet = guide.querySelector('[data-db-duvet]');
      const result = guide.querySelector('[data-db-result]');
      const update = () => {
        const edge = (Number(duvet.value) - Number(mattress.value)) / 2;
        result.replaceChildren();
        const strong = document.createElement('strong');
        strong.textContent = edge > 0 ? edge + ' cm' : 'Sans retombée';
        result.append(strong, document.createTextNode(edge > 0 ? ' de chaque côté' : ' : choisissez une largeur supérieure au matelas.'));
      };
      mattress.addEventListener('change', update);
      duvet.addEventListener('change', update);
      update();
    });
    scope.querySelectorAll('[data-db-filter]').forEach(button => {
      if (button.dataset.dbReady) return;
      button.dataset.dbReady = 'true';
      button.addEventListener('click', () => {
        const root = button.closest('.db-formats');
        root.querySelectorAll('[data-db-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        let count = 0;
        root.querySelectorAll('[data-db-family]').forEach(card => {
          card.hidden = button.dataset.dbFilter !== 'all' && card.dataset.dbFamily !== button.dataset.dbFilter;
          if (!card.hidden) count++;
        });
        root.querySelector('[data-db-filter-count]').textContent = count + (count > 1 ? ' formats affichés' : ' format affiché');
      });
    });

    scope.querySelectorAll('.db-v4-video__media').forEach(video => {
      if (video.dataset.dbReady) return;
      video.dataset.dbReady = 'true';
      video.muted = true;
      video.playsInline = true;

      const status = video.parentElement.querySelector('[data-db-video-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manuallyPaused = false;
      let observerInitiated = false;

      video.addEventListener('pause', () => {
        if (!observerInitiated && video.currentTime > 0) manuallyPaused = true;
      });
      video.addEventListener('play', () => {
        if (!observerInitiated) manuallyPaused = false;
      });

      if (!('IntersectionObserver' in window) || reducedMotion.matches) return;

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          observerInitiated = true;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.45 && !manuallyPaused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                if (status) status.textContent = 'La vidéo a démarré automatiquement sans le son.';
              }).catch(() => {});
            }
          } else if (!video.paused) {
            video.pause();
          }
          window.setTimeout(() => { observerInitiated = false; }, 0);
        });
      }, { threshold: [0, 0.45, 0.8] });

      observer.observe(video);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
